import { useContext, useState } from "react";
import { ContextProfileUser } from "../../lib/profileContext";
import Indicator from "../Indicator";
import InputGlobal from "../InputGlobal";
import { simplyClick, validateEmail } from "../../helpers";
import { useWizardAnswers } from "ui-components";
import ButtonGroup from "../ButtonGroup";
import LoaderEmail from "../LoaderEmail";
import {
  bodyTypes,
  landingId,
  ERROR_EMAIL_ALREADY_REGISTERED,
} from "../../constants";

import skinnyIcon from "../../images/ico_skinny.svg";
import averageIcon from "../../images/ico_average.svg";
import modelIcon from "../../images/ico_model.svg";
import plusIcon from "../../images/ico_plus-size.svg";
import BigIcon from "../../images/ico_big.svg";
import dontCareIcon from "../../images/ico_question-mark.svg";
import Tooltip from "../Tooltip";

import "./Email.scss";

const Email = ({ step, setStep }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorEmail, setErrorEmail] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [selectedIndicator, setSelectedIndicator] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [emailLoader, setEmailLoader] = useState({
    show: false,
    textMain: "",
    textSub: "",
  });
  const updateAnswer = useWizardAnswers();

  const domains = [
    "@gmail.com",
    "@yahoo.com",
    "@hotmail.com",
    "@aol.com",
    "@outlook.com",
    "@comcast.net",
    "@live.com",
    "@mail.com",
    "@msn.com",
    "@att.net",
    "@icloud.com",
  ];

  const handleSelectIndicator = (id) => {
    const selected = bodyTypes[id];
    if (!selected) return;

    setSelectedIndicator(id);
    updateAnswer({ body_type: [String(id)] });

    if (selected.event) {
      simplyClick(selected.event);
    }
  };

  const handlerSubmit = () => {
    if (!selectedIndicator) {
      updateAnswer({ body_type: ["0"] });
    }

    setEmailLoader({
      show: true,
      textMain: "Verifying your email..",
      textSub: "This might take a moment.",
    });

    const textTimeout = setTimeout(() => {
      setEmailLoader({
        show: true,
        textMain: "Still verifying your email...",
        textSub: "Thanks for your patience!",
      });
    }, 3000);

    validateEmail(data.email, (result) => {
      clearTimeout(textTimeout);
      setEmailLoader({ show: false, textMain: "", textSub: "" });

      const { status, error } = result;
      setEmailLoader({
        show: false,
        textMain: "",
        textSub: "",
      });
      if (error === ERROR_EMAIL_ALREADY_REGISTERED) {
        setShowLogin(true);
        setErrorEmail(error);
      } else if (!status) {
        setErrorEmail(error);
      } else {
        simplyClick("cl_lnd_qm3_step4_next");
        setStep(step + 1);
      }
    });
  };

  const handlerStepBack = () => {
    simplyClick("cl_lnd_qm3_step4_back");
    setStep(step - 1);
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setData({ ...data, email: value });
  };

  const setFullEmail = (fullEmail) => {
    setErrorEmail(null);
    setData({ ...data, email: fullEmail });
  };

  return (
    <>
      {emailLoader.show && (
        <LoaderEmail
          textMain={emailLoader.textMain}
          textSub={emailLoader.textSub}
        />
      )}

      <div className="global__form-wrap">
        <div className="email__form">
          <h5 className="form__title">
            What body type do you find most attractive?
          </h5>

          <div className="group__top">
            {[1, 2, 3].map((id, idx) => (
              <Indicator
                key={id}
                textLabel={bodyTypes[id].label}
                iconIndicator={
                  id === 1 ? skinnyIcon : id === 2 ? modelIcon : averageIcon
                }
                className={`component-${id}`}
                isActive={selectedIndicator === id}
                onClick={() => handleSelectIndicator(id)}
              />
            ))}
          </div>

          <div className="group__bottom">
            {[4, 5, 6].map((id) => (
              <Indicator
                key={id}
                textLabel={bodyTypes[id].label}
                iconIndicator={
                  id === 4 ? plusIcon : id === 5 ? BigIcon : dontCareIcon
                }
                className={`component-${id}`}
                isActive={selectedIndicator === id}
                onClick={() => handleSelectIndicator(id)}
              />
            ))}
          </div>

          <span className="line" />
          <h5 className="form__title">Enter your email to create an account</h5>
          <div className="email_input">
            <div className="has-float-label">
              <InputGlobal
                className={
                  "input__global" +
                  (errorEmail ? " error" : "") +
                  (data.email?.length > 0 && !data.email?.includes("@")
                    ? " active"
                    : "")
                }
                onChange={(e) => setEmailValue(e.target.value)}
                name={"email__30"}
                placeholder={"Enter a valid email"}
                type={"text"}
                id={"email__30"}
                value={data.email ? data.email : ""}
                onFocus={() => {
                  if (!data.email) {
                    setShowTooltip(true);
                  }
                  simplyClick("cl_lnd_qm3_step4_type_email");
                }}
                onBlur={() => setShowTooltip(false)}
              />
              <label htmlFor="email__30" className={errorEmail ? "error" : ""}>
                Enter a valid email
              </label>

              {data.email?.length > 0 && !data.email?.includes("@") && (
                <div
                  className={"autocomplete__box" + (errorEmail ? " error" : "")}
                >
                  <ul className="autocomplete__box-list">
                    {domains.map((domain, index) => (
                      <li
                        key={index}
                        className="autocomplete__box-list-item"
                        onClick={() => setFullEmail(data.email + domain)}
                      >
                        {data.email}
                        {domain}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {errorEmail && <p className="error-text">{errorEmail}</p>}
              <Tooltip
                text="We'll use this email for account verification and important notifications."
                showTooltip={showTooltip}
                className="email"
              />
              {showLogin && (
                <div className="email_login-wrap">
                  <a
                    href={`/login/?landing_id=${landingId}${data?.email
                      ? `&email=${encodeURIComponent(data.email)}`
                      : ""
                      }`}
                    id="log-in-email"
                    className="email__login"
                    onClick={() => simplyClick("cl_lnd_qm3_againemail_login")}
                  >
                    Log in
                  </a>{" "}
                  <p className="email_login-text"> or use another email.</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
      </div>
    </>
  );
};

export default Email;
